export const reportRights = [
  {
    name: 'Protokoll',
    function: 'Übersicht',
    access: 'ja'
  },
  {
    name: 'Protokoll',
    function: 'Protokoll speichern',
    access: 'ja'
  },
  {
    name: 'Protokoll',
    function: 'Protokoll drucken',
    access: 'ja'
  },
  {
    name: 'Tageskalender',
    function: 'Übersicht',
    access: 'ja'
  },
  {
    name: 'Tageskalender',
    function: 'Drucken',
    access: 'ja'
  },
  {
    name: 'Tageskalender',
    function: 'Dem Tageskalender hinzufügen',
    access: 'ja'
  },
  {
    name: 'Tageskalender',
    function: 'Tageskalender Suche',
    access: 'ja'
  },
  {
    name: 'Tageskalender',
    function: 'Tageskalender Kopieren',
    access: 'ja'
  },
  {
    name: 'Report',
    function: 'Übersicht',
    access: 'ja'
  },
  {
    name: 'Report',
    function: 'Einträge Filtern',
    access: 'ja'
  },
  {
    name: 'Kunden',
    function: 'Übersicht',
    access: 'ja'
  },
  {
    name: 'Kunden',
    function: 'Neuer Kunde',
    access: 'ja'
  },
  {
    name: 'Kunden',
    function: 'Kunde editieren',
    access: 'ja'
  },
  {
    name: 'Kunden',
    function: 'Kunde inaktiv setzen',
    access: 'ja'
  },
  {
    name: 'Projekte',
    function: 'Übersicht',
    access: 'ja'
  },
  {
    name: 'Projekte',
    function: 'Übersicht',
    access: 'ja'
  },
  {
    name: 'Projekte',
    function: 'Neues Projekt',
    access: 'ja'
  },
  {
    name: 'Projekte',
    function: 'Projekt Edititeren',
    access: 'ja'
  },
  {
    name: 'Projekte',
    function: 'Projekt inaktiv setzen',
    access: 'ja'
  },
  {
    name: 'Vorgaben',
    function: 'allgemeine Freizeiten / Fortbildungen',
    access: 'ja'
  },
  {
    name: 'Vorgaben',
    function: 'neue Freizeit / Fortbildung',
    access: 'ja'
  },
  {
    name: 'Vorgaben',
    function: 'editieren Freizeit / Fortbildung',
    access: 'ja'
  },
  {
    name: 'Vorgaben',
    function: 'löschen Freizeit / Fortbildung',
    access: 'ja'
  },
  {
    name: 'Vorgaben',
    function: 'Leistungen Übersicht',
    access: 'ja'
  },
  {
    name: 'Vorgaben',
    function: 'Leistungen Anlegen',
    access: 'ja'
  },
  {
    name: 'Vorgaben',
    function: 'Leistungen Editieren',
    access: 'ja'
  },
  {
    name: 'Vorgaben',
    function: 'Leistungen Inaktiv setzen',
    access: 'ja'
  },
  {
    name: 'Vorgaben',
    function: 'Textbausteine Übersicht',
    access: 'ja'
  },
  {
    name: 'Vorgaben',
    function: 'Textbausteine Anlegen',
    access: 'ja'
  },
  {
    name: 'Vorgaben',
    function: 'Textbausteine Editieren',
    access: 'ja'
  },
  {
    name: 'Vorgaben',
    function: 'Textbausteine Inaktiv setzen',
    access: 'ja'
  },
  {
    name: 'Vorgaben',
    function: 'Abwesenheiten Übersicht',
    access: 'ja'
  },
  {
    name: 'Vorgaben',
    function: 'Abwesenheiten Anlegen',
    access: 'ja'
  },
  {
    name: 'Vorgaben',
    function: 'Abwesenheiten Editieren',
    access: 'ja'
  },
  {
    name: 'Vorgaben',
    function: 'Abwesenheiten Inaktiv setzen',
    access: 'ja'
  },
  {
    name: 'Team',
    function: 'Übersicht',
    access: 'ja'
  },
  {
    name: 'Team',
    function: 'Rollen und Rechte',
    access: 'ja'
  },
  {
    name: 'Team',
    function: 'Anlegen',
    access: 'ja'
  },
  {
    name: 'Team',
    function: 'Bearbeiten',
    access: 'ja'
  },
  {
    name: 'Team',
    function: 'inaktiv setzen',
    access: 'ja'
  },
  {
    name: 'Team',
    function: 'Passwort ändern',
    access: 'ja'
  },
  {
    name: 'Benutzer',
    function: 'Passwort ändern',
    access: 'ja'
  },
  {
    name: 'Benutzer',
    function: 'logout',
    access: 'ja'
  }
]
